import React, { Component } from "react";
import Axios from "axios";

export class AssineButton extends Component {
    constructor(props) {
      super(props);
    }

    setCookie (name, value, domain) {
      let date = new Date(Date.now() + (60 * 60 * 24 * 1000)),
          cookieObject = {
            [name]: value,
            "path": "/",
            "domain": process.env.REACT_APP_GB_COOKIE_ROOT,
            "expires": date.toUTCString()
          },
          cookie = [];

      for (let key of Object.keys(cookieObject)) {
        if (cookieObject[key]) cookie.push(`${key}=${cookieObject[key]}`);
      }

      document.cookie = cookie.join(";");
    }

    isCookieSet (name) {
      return (document.cookie.indexOf(name) !== -1);
    }

    render() {
      let {personalUseCoupon, personId, subscriberId, subscriptionTypeId} = this.props;
      let redirectURL;
      let renewal = false;

      if (subscriptionTypeId === 1) {
        renewal = true
      } else {
        renewal = false
      }

      if (personalUseCoupon) {

        redirectURL = `${process.env.REACT_APP_GB_ASSINE}${personalUseCoupon.name}?personId=${personId}&subscriberId=${subscriberId}&isRenewal=${personalUseCoupon.isRenewal}&itm_source=glambox.com.br&itm_medium=referral&itm_campaign=botao-promocional&itm_content=plano-mensal`;

        if (personalUseCoupon.isRenewal) {
          this.setCookie("gbIsRenewal", true);
        }

      }

        return (
          <a href={redirectURL}
          className="btn btn-blue-alert gbBt small"
          >
            ASSINE
          </a>
        )
    }
  }
